module.exports = __webpack_public_path__ + "images/emoji/umbrella.8dbbc8daf5cd649f9c7f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/umbrella.png
// module id = Vkz2
// module chunks = 14